import type { MessagingSendMessage201AllOfSenderBasicInfo } from './messagingSendMessage201AllOfSenderBasicInfo';
import type { MessagingSendMessage201AllOfSenderSocial } from './messagingSendMessage201AllOfSenderSocial';

/**
 * 발신자 정보
 */
export type MessagingSendMessage201AllOfSender = {
  /** 사용자 기본 정보 */
  basicInfo: MessagingSendMessage201AllOfSenderBasicInfo;
  /** 소셜 관계 정보 */
  social?: MessagingSendMessage201AllOfSenderSocial;
};
